import { baseApi } from 'services/api';
import { API_VERSION } from 'constants/common';
import { LegalAgreementAcceptancePayload, LegalReacceptanceContent } from './legalReacceptance.model';

const legalReacceptanceApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getLegalReacceptanceContent: builder.query<LegalReacceptanceContent, void>({
      query: () => ({
        url: `${API_VERSION.V1}/legal-agreements/reacceptance-terms`,
        method: 'GET'
      })
    }),
    confirmLegalReacceptance: builder.mutation<void, { teamId: number; payload: LegalAgreementAcceptancePayload }>({
      query: ({ teamId, payload }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/legal-agreement-acceptance`,
        method: 'POST',
        body: payload
      })
    })
  })
});

export const { useLazyGetLegalReacceptanceContentQuery, useConfirmLegalReacceptanceMutation } = legalReacceptanceApi;
